export enum DeviceOption {
    Ipad = "iPad",
    IPhone = "iPhone",
    Both = "both",
}

export enum AppsPriceType {
    Free = "free",
    Paid = "paid",
}

export enum AppsCategoryTypes {
    All = "all",
    Primary = "primary",
}
